/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_Bad_DaysInputs */



/**
* | output |
* | --- |
* | "Even mint-condition apps have bad days." |
*
* @param {Error_Subtext_Bad_DaysInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_bad_days = /** @type {((inputs?: Error_Subtext_Bad_DaysInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_Bad_DaysInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auch Apps in Mint-Zustand haben schlechte Tage.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Même les applis en état mint ont de mauvais jours.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("就算是全新品相的应用也有不顺的时候。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("就算是全新未拆的 app 也會有不順的一天。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("민트 상태인 앱에도 안 좋은 날은 있습니다.")
	return /** @type {LocalizedString} */ ("Even mint-condition apps have bad days.")
});